import AppBar from './AppBar';
import AppRouter from './routes/AppRouter';
import ErrorPage from '@components/common/ErrorPage';
import React, {useEffect, useState} from 'react';
import ScrollContainer from './ScrollContainer';
import Sidebar from './sidebar/Sidebar';
import {Box, Container, styled} from '@mui/material';
import {
  DEFAULT_PARAMS,
  PRODUCT_VARIANTS_KEY,
  REFRESH_INTERVAL_MS,
} from '@hooks/data/products/constants';
import {getProductVariants} from '@account/api';
import {useAuth} from '@apps-common/auth-react';
import {useQueryClient} from '@tanstack/react-query';

const Content = styled(Container)(({theme}) => ({
  display: 'flex',
  flexDirection: 'column',
  flexGrow: 1,
  flexShrink: 1,
  flex: 0,
  paddingBottom: theme.spacing(2),
  height: '100%',
  minHeight: 500,
}));

const AppLayout = () => {
  const auth = useAuth();
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const queryClient = useQueryClient();

  useEffect(() => {
    // Prefetch product variants when the app loads
    queryClient.prefetchQuery({
      queryKey: PRODUCT_VARIANTS_KEY,
      queryFn: () => getProductVariants(DEFAULT_PARAMS),
      staleTime: REFRESH_INTERVAL_MS,
      refetchInterval: REFRESH_INTERVAL_MS,
    });
  }, [queryClient]);

  const errorLoadingUserInformation =
    !auth.user.claims || !auth.user?.claims.role_level;

  return (
    <Box display="flex" flexDirection="column" height="100%" overflow="hidden">
      <AppBar onMenuClick={() => setSidebarOpen(!sidebarOpen)} />

      <Box display="flex" height="100%" overflow="hidden">
        {errorLoadingUserInformation ? (
          <ErrorPage statusMessage="An unforeseen error occurred while fetching your user data." />
        ) : (
          <>
            <Sidebar open={sidebarOpen} onClose={() => setSidebarOpen(false)} />
            <ScrollContainer>
              <Content>
                <AppRouter />
              </Content>
            </ScrollContainer>
          </>
        )}
      </Box>
    </Box>
  );
};

export default AppLayout;
